<template>
    <form-field v-bind="fieldProps">
        <radio-input v-bind="inputProps" @change="change($event)" @emitEvent="emitEvent($event, ['change'])"></radio-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            options: { type: Array, required: true },
            direction: { type: String, default: null },
            checkedIcon: { type: String, default: null },
        },
    }
</script>
